<template>
    <div id="userList">
        <div class="searchContent">
            <!--<div class="p_select el_select_org">
                <div class="search_label">检测站点</div>
                <el-select v-model="orgId" clearable filterable placeholder="请选择检测站点" @change="queryOrgData">
                    <el-option v-for="item in orgArr" :key="item.orgId" :label="item.orgName" :value="item.orgId"></el-option>
                </el-select>
            </div>
            <div class="p_select">
                <a  class="search_btn" @click="getListData">查询</a>
            </div>-->
            <div class="p_select">
                <a  class="add_btn" @click="addItem"><i class="el-icon-plus"></i>新增</a>
            </div>
        </div>
        <div class="list_content">
            <el-table :data="devicelistData" :height=winHeight>
                <el-table-column prop="dictionaryId" align="left" label="ID"></el-table-column>
                <el-table-column prop="dictionaryName" align="left" label="名称"></el-table-column>
                <el-table-column prop="orderIndex" align="left" label="排序字段"></el-table-column>
                <el-table-column label="状态" align="left">
                    <template slot-scope="scope">
                        <el-switch
                                v-model="scope.row.isUsing"
                                active-color="#ff4949"
                                inactive-color="#13ce66"
                                active-value="0"
                                inactive-value="1"
                                active-text="禁用"
                                inactive-text="启用"
                                @change="changUsing(scope.row, scope.row.isUsing)">
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" align="left">
                    <template slot-scope="scope">
                        <el-button
                                @click="getDictionList(scope.row)"
                                class="update_btn"
                                style="width: 90px"
                                size="small"
                        >查看列表</el-button>
                        <el-button
                                @click="updateDiction(scope.row)"
                                class="update_btn"
                                size="small"
                        >修改</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination">
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    background
                    :current-page="pageNo"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
            ></el-pagination>
        </div>


        <el-drawer
                title="新增留言板字典"
                :visible.sync="showAddData"
                direction="rtl"
                :wrapperClosable=true
                @close="noAddData">
            <el-form ref="form" :model="dicForm" label-width="100px" style="height: 300px">
                <el-form-item label="字典名称:" required>
                    <el-input v-model="dicForm.dictionaryName" placeholder="请输入字典名称"></el-input>
                </el-form-item>
                <el-form-item label="排序字段:" required>
                    <el-input v-model="dicForm.orderIndex" placeholder="请输入排序字段"></el-input>
                </el-form-item>
            </el-form>
            <div class="position_box_btn">
                <a class="sure_btn" @click="submitAdd">确认新增</a>
                <a class="cancel_btn" @click="noAddData">取消</a>
            </div>
        </el-drawer>
        <el-drawer
                title="修改留言板字典"
                :visible.sync="showEditData"
                direction="rtl"
                :wrapperClosable=true
                @close="noUpdateData">
            <el-form ref="form" :model="dicForm" label-width="100px" style="height: 300px">
                <el-form-item label="字典ID:">
                    <el-input v-model="dicForm.dictionaryId" disabled></el-input>
                </el-form-item>
                <el-form-item label="字典名称:" required>
                    <el-input v-model="dicForm.dictionaryName" placeholder="请输入字典名称"></el-input>
                </el-form-item>
                <el-form-item label="排序字段:" required>
                    <el-input v-model="dicForm.orderIndex" placeholder="请输入排序字段"></el-input>
                </el-form-item>
            </el-form>
            <div class="position_box_btn">
                <a class="sure_btn" @click="submitEdit">确认修改</a>
                <a class="cancel_btn" @click="noUpdateData">取消</a>
            </div>
        </el-drawer>


    </div>
</template>

<script>
  import net from "../../assets/js/public";
  export default {
    name: "messageManage", //留言
    data() {
      return {
        devicelistData:[],

        total:0,
        pageNo:1,
        pageSize:10,
        showAddData: false,
        dicForm:{
          orgId: '',
          dictionaryName: '',
          orderIndex: '',
          dictionaryId:'',
        },
        showEditData: false,
        winHeight:"220",

        orgArr: [],
        orgId: '',
        orgName: "",




      };
    },
    created() {
      var signInfo = JSON.parse(sessionStorage.getItem("signInfo"));

      if (signInfo.orgId > 0) {
        this.orgId = signInfo.orgId
      }

      this.getListData()
    },
    methods: {
      getListData() {
        const params = {
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          orgId: this.orgId
        }
        net.request("admin/manage/message/dictionary/typeList","post",null,params).then(res => {
          if (res.code === 0) {
            let devicelistData = res.data.rows
            devicelistData.forEach(item => {
              item.isUsing = item.isUsing+''
            })
            this.devicelistData = devicelistData
            this.total = res.data.total
            this.winHeight = net.setWindowHeight()-36

          } else {
            net.message(this, res.msg, "warning");
          }
        })
      },
      addItem(){
        this.showAddData = true
        this.dicForm.dictionaryName = ''
        this.dicForm.orgId = this.orgId
      },
      submitAdd(){
        if(this.dicForm.dictionaryName == '' || this.dicForm.dictionaryName == null || this.dicForm.orgId == '' || this.dicForm.orgId == null ){
          net.message(this, '必填项不能为空', "error");
          return
        }
        const params = {
          dictionaryName:this.dicForm.dictionaryName,
          orgId:this.dicForm.orgId,
          orderIndex: this.dicForm.orderIndex,
          isUsing:1
        }
        net.request("admin/manage/message/dictionary/addType", "post", params ).then(res => {
          if (res.code === 0) {
            net.message(this, res.msg, "success");
          } else {
            net.message(this, res.msg, "warning");
          }
          this.showAddData = false
          this.getListData()
        });
      },
      noAddData(){
        this.showAddData = false
        this.getListData()
      },
      getDictionList(row){
        sessionStorage.setItem("messageManage", JSON.stringify(row));
        this.$router.push({ path: '/messageManageDetail' });

      },
      updateDiction(row){
        this.showEditData = true
        this.dicForm = row
      },
      submitEdit(){
        if(this.dicForm.dictionaryName == '' || this.dicForm.dictionaryName == null ){
          net.message(this, '必填项不能为空', "error");
          return
        }
        const params  = {
          dictionaryId:this.dicForm.dictionaryId,
          dictionaryName:this.dicForm.dictionaryName,
          orderIndex:this.dicForm.orderIndex,
          isUsing:this.dicForm.isUsing,
        }
        net.request("admin/manage/message/dictionary/editType", "post", params).then(res => {
          if (res.code === 0) {
            net.message(this, res.msg, "success");
          } else {
            net.message(this, res.msg, "warning");
          }
          this.showEditData = false
          this.getListData()
        });
      },
      // 修改状态
      changUsing(row, isUsing){
        const param = {
          dictionaryId:row.dictionaryId,
          dictionaryName:row.dictionaryName,
          orderIndex:row.orderIndex,
          isUsing: parseInt(isUsing)
        }
        net.request("admin/manage/message/dictionary/editType", "post", param).then(res => {
          if (res.code === 0) {
            net.message(this, res.msg, "success");
          } else {
            net.message(this, res.msg, "warning");
          }
          this.getListData()
        })
      },
      noUpdateData(){
        this.showEditData = false
        this.getListData()
      },
      handleSizeChange(val) {
        this.pageSize = val;
        this.getListData()
      },
      handleCurrentChange(val) {
        this.pageNo = val
        this.getListData()
      },
    }
  };
</script>

<style lang="less" scoped>
    /deep/ .el-table th.el-table__cell {
        background: #F3F7FB !important;
        color: #364556;
    }
    #userList {
        padding-left: 24px;
        .searchContent {
            background: #fff;
            margin: 24px 0 0px 0;
            /*display: flex;*/
            /*flex-direction: row;*/
            padding-left: 12px;
            padding-top: 12px;
            .p_select {
                display: flex;
                padding: 0 12px 12px 0;
                font-size: 12px;
                float: left;
                .search_label{
                    font-family: 'PingFang SC';
                    font-style: normal;
                    margin-right: 12px;
                    font-weight: 500;
                    font-size: 14px;
                    line-height: 40px;
                    color: #787E86;
                    white-space:nowrap
                }

                .el-input , .el-select{
                    width: 160px;
                }
            }
            .search_btn {
                width: 76px;
                height: 36px;
                line-height: 36px;
                background: #2B54FC;
                box-shadow: 0px 4px 12px rgba(71, 134, 192, 0.24);
                border-radius: 4px;
                color: #FFFFFF;
                font-size: 14px;
            }
            .add_btn {
                width: 76px;
                height: 36px;
                line-height: 36px;
                background: rgba(148, 170, 204, 0.08);
                border: 1px solid #2B54FC;
                border-radius: 4px;
                font-size: 14px;
                color: #2B54FC;
            }

        }
        .list_content {
            background: #fff;
            padding-left: 12px;
            padding-right: 12px;
        }
        .pagination {
            position: relative;
            margin-top: 0;
            background: #fff;
            padding-top: 12px;
            padding-bottom: 10px;
            .el-pagination {
                position: absolute;
                right: 24px;
                .el-pager li:not(.disabled) {
                    .active {
                        background: #009688 !important;
                    }
                }
            }
        }

        .el-pagination.is-background .el-pager li:not(.disabled).active {
            background: #009688;
        }
        .update_btn {
            width: 54px;
            height: 28px;
            background: rgba(148, 170, 204, 0.08);
            border: 1px solid #E3E7ED;
            border-radius: 14px;
            font-size: 12px;
            color: #364556;
            text-align: center;
        }
    }
    .orgLabelSet {
        width: 660px;
        // background-color: red;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
    }
    .orgLabel {
        width: 220px;
        padding-top: 5px;
        padding-bottom: 5px;
        text-align: left;
    }
    .el-input , .el-select{
        width: 100%;
    }
</style>
